/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, Icon, message, Table, Drawer, Empty } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import AddForm from './addForm'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isEdit: false,
			selectedBarangayPosition: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText,
			isAddFormShown, isEdit, selectedBarangayPosition
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					<Row>
						<button type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
							this.setState({ isAddFormShown: true, isEdit: false, selectedBarangayPosition: null })
						}} style={{ float: 'right' }}>Add New</button>
						<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
							this.setState({ searchText: e.target.value })
						}}/>
					</Row>
					<br />
					<Row>
						<Query query={BARANGAY_POSITIONS} variables={{ searchFilter: filters, barangay_uid }}>
							{({ loading, error, data }) => {
								if (error) return <Empty/>

								let barangayPositions = _.has(data,'barangayPositions') ? data.barangayPositions.data : []
								barangayPositions = barangayPositions.map((barangayPosition, key) => Object.assign({}, barangayPosition, { key }))
								let _pagination = _.has(data, 'barangayPositions') ? data.barangayPositions.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								const columns = [
									{
									 	title: 'Position',
									 	dataIndex: 'name',
									 	key: 'name',
									 	//width: 300
									}, {
										title: 'Description',
										dataIndex: 'description',
										key: 'description'
									}, {
										title: 'Max Count',
										dataIndex: 'max_count',
										key: 'max_count'
									}, {
										title: 'Action',
										key: 'action',
										render: (record) => {
											return (
												<React.Fragment>
													<a href="#" onClick={() => this.setState({ isAddFormShown: true, isEdit: true, selectedBarangayPosition: record })}>Edit</a>
												</React.Fragment>
											)
										}
									}]
								return (
									<Table 
										loading={loading}
										columns={columns} 
										dataSource={barangayPositions} 
										bordered
										onChange={this.handleOnChange}
										pagination={_pagination}
										scroll={{ x: 1020 }}
									/>
								)
							}}
						</Query>
					</Row>
					{
						isAddFormShown &&
                        <AddForm
                        	isEdit={isEdit}
                        	selectedBarangayPosition={selectedBarangayPosition}
                        	visible={isAddFormShown}
                        	onClose={() => this.setState({ isAddFormShown: false, isEdit: false, selectedBarangayPosition: null })}
                        />
					}
				</Col>
			</Row>
		)
	}
}

const BARANGAY_POSITIONS = gql`
    query barangayPositions($barangay_uid: String, $searchFilter: SearchParams) {
		barangayPositions(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
